<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4>Danh sách kỳ lương</h4>
          </div>
          <div class="text-right">
            <el-button
              v-if="mData.dataDefault.listFeature.includes('FT1105')"
              class="pl-2 btn-default"
              round
              @click="dialogSalaryConfig = true"
            >
              Cấu hình tải lương
            </el-button>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table mt-2">
            <el-table
              :data="mData.tableRules.data"
              border
              @selection-change="fn_tableSelectionChange"
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column
                type="selection"
                width="40"
                v-if="mData.tableRules.allowSelect"
              ></el-table-column>
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="Tên bảng lương"
                min-width="280"
              ></el-table-column>
              <el-table-column
                prop="created_at"
                label="Ngày tạo"
                min-width="75"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="ten_nguoi_tao"
                label="Người tạo"
                min-width="150"
              ></el-table-column>
              <el-table-column prop="sealed" label="Trạng thái" min-width="120">
                <template slot-scope="scope">
                  <div
                    class="text-center"
                    :class="{
                      red: scope.row.sealed === 'REJECTED',
                      green: scope.row.sealed === 'APPROVED',
                      orange: scope.row.sealed === 'WAITING_FOR_APPROVAL',
                    }"
                  >
                    {{
                      scope.row.sealed === "WAITING_FOR_APPROVAL"
                        ? `Chờ duyệt`
                        : scope.row.sealed === "APPROVED"
                        ? `Đã duyệt`
                        : scope.row.sealed === "REJECTED"
                        ? `Từ chối`
                        : "Mới"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="left"
                width="155px"
                v-if="
                  mData.dataDefault.listFeature.includes('FT1102') ||
                  mData.dataDefault.listFeature.includes('FT1104')
                "
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="'Chi tiết'"
                    v-if="
                      mData.dataDefault.listFeature.includes('FT1102') ||
                      mData.dataDefault.listFeature.includes('FT1104')
                    "
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    :disabled="!scope.row.isHaveFile"
                    type="success"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('download', scope.$index, scope.row)"
                    v-b-popover.hover.left="'Tải xuống'"
                    v-if="mData.dataDefault.listFeature.includes('FT1102')"
                  >
                    <i class="fas fa-download"></i>
                  </el-button>
                  <el-button
                    v-if="
                      !scope.row.isSealed &&
                      mData.dataDefault.listFeature.includes('FT1103') &&
                      scope.row.sealed != 'WAITING_FOR_APPROVAL'
                    "
                    type="primary"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="'Cập nhật'"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialog_config"
      title="Cấu hình xử lý tính lương"
      :visible.sync="dialogSalaryConfig"
      width="40%"
      :before-close="handleClose"
    >
      <div>
        <p class="mb-4 title-salary">"Hiệu lực bắt đầu từ kỳ lương sau"</p>
      </div>
      <el-radio-group class="d-flex1" v-model="mData.dataForm.is_approved">
        <el-radio :label="false" v-model="mData.radioConfig"
          >Import File tính lương đã duyệt. Hệ thống chỉ gửi thông tin đến mọi
          người</el-radio
        >
        <el-radio :label="true" v-model="mData.radioConfig"
          >Import File tính lương chưa duyệt. - Thực hiện duyệt trên hệ thống -
          Sau khi duyệt xong sẽ gửi thông tin đến mọi người</el-radio
        >
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          class="btn-default"
          @click="changeStatusapproved(mData.radioConfig)"
          >Lưu</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExtensionService from "../../../../service/ExtensionService";
import LanguageService from "../../../../service/LanguageService";
import MethodService from "../../../../service/MethodService";
import SalaryModel from "../SalaryModel";
import ProfileApi from "../../../../moduleApi/ProfileApi";
import SalaryConfigApi from "../../../../moduleApi/SalaryConfigApi";
import SalaryPeriodApi from "../../../../moduleApi/SalaryPeriodApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      test: true,
      dialogSalaryConfig: false,
      mData: {
        radioConfig: false,
        data: [],
        moduleName: "SalaryPeriod", //requied
        dataForm: {
          company_id: undefined,
          is_approved: undefined,
        },
        tableRules: MethodService.copyObject(SalaryModel.tableRules),
        dataDefault: {
          listNguoiTao: [],
          listFeature: MethodService.getListFeatures(),
        },
        companyInfo: {},
        currentUser: {},
      },
    };
  },

  methods: {
    handleClose() {
      this.dialogSalaryConfig = false;
      setTimeout(() => {
        this.fn_getSalaryConfig();
      }, 300);
    },
    async fn_getSalaryConfig() {
      this.mData.companyInfo = MethodService.getCompanyInfo();
      this.mData.currentUser = MethodService.getCurrentUser();
      const salaryConfigApiRes = await SalaryConfigApi.list();
      if (salaryConfigApiRes.result.length > 0) {
        this.mData.dataForm = salaryConfigApiRes.result[0];
      }
    },
    async fn_initTable() {
      let dataFilter = {
        // filters: "created_user_id="+this.mData.currentUser.id + "|sealed_users.sealed_user_id="+this.mData.currentUser.id
        filters: "",
        sort: "-from_date",
      };
      const salaryPeriodApiRes = await SalaryPeriodApi.list(dataFilter);
      let resData = await this.fn_changeData(salaryPeriodApiRes.result);
      this.mData.tableRules.data = resData;
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let createrUserIds = [];
      createrUserIds = MethodService.findListItemDifferent(
        resData,
        "created_user_id"
      );
      const reqNguoiTaoApi = await ProfileApi.list(
        {
          limit: createrUserIds.length,
          filters: "id:in:" + createrUserIds.join(","),
        },
        true
      );
      let resNguoiTaoApi = await reqNguoiTaoApi;
      this.mData.dataDefault.listNguoiTao = resNguoiTaoApi.result;
      resData.forEach((row) => {
        if (row.created_user_id == this.mData.currentUser.id) {
          row.isNguoiTao = true;
        } else {
          row.isNguoiTao = false;
        }
        if (row.sealed === "APPROVED") {
          row.isSealed = true;
        } else {
          row.isSealed = false;
        }
        if (row.file_id) {
          row.isHaveFile = true;
        } else {
          row.isHaveFile = false;
        }
        row.created_at = MethodService.formatDate(row.created_at, "date");
        let nguoiTao = this.mData.dataDefault.listNguoiTao.find((element) => {
          return element.id == row.created_user_id;
        });
        if (nguoiTao && nguoiTao.name && nguoiTao.name.full_name) {
          row.ten_nguoi_tao = nguoiTao.name.full_name;
        }
      });
      return resData;
    },
    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_handle(type, scope, row) {
      if (type == "import") {
        this.$router.push({
          name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-Salary-SalaryPeriod-SalaryPeriodList-detail",
          params: { id: row.id }
        });
      }
      if (type == "download") {
        if (row.file_id) window.open(ExtensionService.urlDowloadFile + row.file_id)
        if (row.tax_file_id) window.open(ExtensionService.urlDowloadFile + row.tax_file_id)
        if (row.insurance_file_id) window.open(ExtensionService.urlDowloadFile + row.insurance_file_id)
      }
    },
    async changeStatusapproved(status) {
      let data = this.mData.dataForm;
      data.company_id = this.mData.companyInfo.id;
      if (!this.mData.dataForm.id) {
        try {
          await SalaryConfigApi.create(data);
          window.toastr.success("Cập nhật cấu hình tải lương thành công!");
          this.fn_getSalaryConfig();
          this.dialogSalaryConfig = false;
        } catch (error) {
          window.toastr.success("Cập nhật cấu hình tải lương thất bại!");
        }
      } else if (this.mData.dataForm.id) {
        try {
          data.id = this.mData.dataForm.id;
          await SalaryConfigApi.update(data);
          window.toastr.success("Cập nhật cấu hình tải lương thành công!");
          this.fn_getSalaryConfig();
          this.dialogSalaryConfig = false;
        } catch (error) {
          window.toastr.success("Cập nhật cấu hình tải lương thất bại!");
        }
      }
    },
  },

  //run after render view
  created() {
    this.fn_getSalaryConfig();
    this.fn_initTable();
  },
  mounted() {},
};
</script>
<style scoped>
::v-deep .el-dialog__body {
  padding: 5px 20px;
}
.title-salary {
  font-size: 15px;
  font-weight: bold;
  font-style: italic;
}
.button-fake {
  background-color: #a0cfff;
  border-color: #a0cfff;
}
.button-fake:hover {
  cursor: no-drop;
}
.d-flex1 {
  display: flex;
  flex-direction: column;
}
.green {
  color: #00cc33;
}
.red {
  color: red;
}
.orange {
  color: rgb(255, 153, 0);
}
::v-deep .dialog_config .el-dialog__body .el-radio-group .el-radio {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
::v-deep
  .dialog_config
  .el-dialog__body
  .el-radio-group
  .el-radio
  .el-radio__label {
  white-space: initial;
  word-break: break-word;
}
::v-deep .el-popover {
  word-break: initial;
  padding: 5px;
}
</style>
